"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutoRegisterRules = void 0;
const sdk_1 = require("../sdk");
var AutoRegisterRules;
(function (AutoRegisterRules) {
    AutoRegisterRules.Document = AutoRegisterRules;
    AutoRegisterRules.list = (options) => {
        const url = '/auto-register-rules';
        return sdk_1.SDK.axios.get((0, sdk_1.appendSearchParams)(url, options));
    };
    AutoRegisterRules.create = (data) => {
        const url = '/auto-register-rules';
        return sdk_1.SDK.axios.post(url, data);
    };
    AutoRegisterRules.get = (autoRegisterRuleId) => {
        const url = `/auto-register-rules/${autoRegisterRuleId}`;
        return sdk_1.SDK.axios.get(url);
    };
    AutoRegisterRules.update = (autoRegisterRuleId, data) => {
        const url = `/auto-register-rules/${autoRegisterRuleId}`;
        return sdk_1.SDK.axios.put(url, data);
    };
    AutoRegisterRules.remove = (config) => {
        const url = `/auto-register-rules`;
        return sdk_1.SDK.axios.delete(url, config);
    };
})(AutoRegisterRules = exports.AutoRegisterRules || (exports.AutoRegisterRules = {}));
//# sourceMappingURL=auto-register-rules.js.map